export enum Direction {
    ASC = 'ASC',
    DESC = 'DESC',
  }
  